import styled from 'styled-components';
import AnnouncementBar from '@nubank/nuds-web/patterns/AnnouncementBar/AnnouncementBar';

export const StyledAnnouncementBar = styled(AnnouncementBar)`
  z-index: -1;
`;

StyledAnnouncementBar.displayName = 'AnnouncementBar';

